export const resolveSafeReturnPage = (returnPage, entryUrl) => {
    if (!returnPage || !entryUrl) return ''
    try {
        const target = new URL(returnPage)
        const entry = new URL(entryUrl)
        if (target.protocol !== 'https:' || target.origin !== entry.origin) return ''
        const basePath = entry.pathname.replace(/\/+$/, '') || '/'
        const targetPath = target.pathname.replace(/\/+$/, '') || '/'
        if (targetPath !== basePath && !targetPath.startsWith(`${basePath}/`)) return ''
        return target.toString()
    } catch (error) {
        return ''
    }
}

export const OWNER_DIRECT_ENTRY_PARAM = '__lechun_vibe_owner_direct_entry_v1__'
export const OWNER_DIRECT_ENTRY_VALUE = 'ams_permission_console'

export const buildOwnerDirectEntryUrl = value => {
    if (!value) return ''
    try {
        const url = new URL(value)
        if (url.protocol !== 'https:') return ''
        url.searchParams.delete(OWNER_DIRECT_ENTRY_PARAM)
        url.searchParams.set(OWNER_DIRECT_ENTRY_PARAM, OWNER_DIRECT_ENTRY_VALUE)
        return url.toString()
    } catch (error) {
        return ''
    }
}

export const buildApplicationEntryUrl = value => {
    if (!value) return ''
    try {
        const url = new URL(value)
        if (url.protocol !== 'https:') return ''
        url.searchParams.delete(OWNER_DIRECT_ENTRY_PARAM)
        return url.toString()
    } catch (error) {
        return ''
    }
}

const normalizeAppPath = (basePath, rawPath) => {
    const pathname = String(rawPath || '/').split('?')[0]
    const normalized = pathname.startsWith('/') ? pathname : `/${pathname}`
    if (!basePath || basePath === '/') return normalized || '/'
    if (normalized === basePath || normalized.startsWith(`${basePath}/`)) return normalized
    if (normalized === '/') return `${basePath}/`
    return `${basePath}${normalized}`
}

export const buildSafePagePreviewUrl = (entryUrl, pathOrUrl) => {
    if (!entryUrl || !pathOrUrl) return ''
    const raw = String(pathOrUrl).trim()
    if (!raw || raw === '-') return ''
    if (/^https?:\/\//i.test(raw)) return resolveSafeReturnPage(raw, entryUrl)
    try {
        const entry = new URL(entryUrl)
        if (entry.protocol !== 'https:') return ''
        const basePath = entry.pathname.replace(/\/+$/, '') || '/'
        const [pathname, search = ''] = raw.split('?')
        const preview = new URL(entry.origin)
        preview.pathname = normalizeAppPath(basePath, pathname)
        if (search) preview.search = search
        return resolveSafeReturnPage(preview.toString(), entryUrl)
    } catch (error) {
        return ''
    }
}
